module.exports = __webpack_public_path__ + "media/images/menu-icons/eat-73d9ba36b2cf2e25df5d9b02435aad13.svg";